import React from 'react';
import { Section } from '../ui/Section';
import { Card } from '../ui/Card';
import { AlertTriangle, Smartphone, BookOpen } from 'lucide-react';
export function PorQueFalla() {
  return <Section background="white" data-id="element-199">
      <div className="text-center mb-16" data-id="element-200">
        <h2 className="text-3xl md:text-4xl font-bold text-stone-900 mb-6" data-id="element-201">
          Por qué lo que probaste antes no se sostuvo.
        </h2>
        <p className="text-lg text-stone-600 max-w-2xl mx-auto" data-id="element-202">
          Porque casi todo está diseñado para alguien con más tiempo, más plata,
          más ganas, y una vida que no se desarma.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-203">
        <Card className="p-8 text-center hover:border-red-200 transition-colors" data-id="element-204">
          <div className="w-12 h-12 bg-red-50 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-205">
            <BookOpen className="w-6 h-6 text-red-500" data-id="element-206" />
          </div>
          <h3 className="text-xl font-bold text-stone-900 mb-3" data-id="element-207">
            Recetas sueltas
          </h3>
          <p className="text-stone-600" data-id="element-208">
            Te dejan sola con la pregunta: <br data-id="element-209" />
            <em data-id="element-210">"¿y mañana qué?"</em>
          </p>
        </Card>

        <Card className="p-8 text-center hover:border-red-200 transition-colors" data-id="element-211">
          <div className="w-12 h-12 bg-red-50 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-212">
            <AlertTriangle className="w-6 h-6 text-red-500" data-id="element-213" />
          </div>
          <h3 className="text-xl font-bold text-stone-900 mb-3" data-id="element-214">Dietas</h3>
          <p className="text-stone-600" data-id="element-215">Te llenan de reglas y culpa.</p>
        </Card>

        <Card className="p-8 text-center hover:border-red-200 transition-colors" data-id="element-216">
          <div className="w-12 h-12 bg-red-50 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-217">
            <Smartphone className="w-6 h-6 text-red-500" data-id="element-218" />
          </div>
          <h3 className="text-xl font-bold text-stone-900 mb-3" data-id="element-219">Apps</h3>
          <p className="text-stone-600" data-id="element-220">
            Te piden registrar y medir cuando lo que te falta es energía mental.
          </p>
        </Card>
      </div>

      <div className="mt-12 text-center bg-stone-50 p-8 rounded-2xl border border-stone-100" data-id="element-221">
        <p className="text-lg text-stone-700" data-id="element-222">
          Ninguna de esas opciones resuelve el problema real: la falta de
          estructura.
          <br data-id="element-223" />
          <strong className="text-stone-900 text-xl block mt-2" data-id="element-224">
            Este PDF sí.
          </strong>
        </p>
      </div>
    </Section>;
}